angular.module('magpieExportedDataSourceFile', [
  'ui.bootstrap',
  'magpieUtil'
]).
controller('MagpieExportedDatasourceFileCtrl', function($scope, $http, baseUrlSrv) {
  $scope.downloadResult = function() {
    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/file', $scope.result, {responseType: 'arraybuffer'})
        .then((response) => {
          return new Blob([new Uint8Array(response.data)], {type: 'application/octet-stream'});
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          angular.element('body').append('<a id="exportedResult"></a>');
          const link = angular.element('body > a#exportedResult');
          link.attr('href', url);

          let fileName = $scope.result.file;

          if(fileName.indexOf('/') >= 0) {
            const fileNameArray = fileName.split('/');
            fileName = fileNameArray[fileNameArray.length - 1];
          }

          link.attr('download', fileName);
          link.attr('target', '_blank');
          link[0].click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          $scope.error = error;
        });
  };
}).
directive('magpieExportedDataSourceFile', function() {
  return {
    restrict: 'E',
    scope: {
      result: '='
    },
    templateUrl: 'components/magpie-display/exports/exported-data-source-file.html',
    controller: 'MagpieExportedDatasourceFileCtrl'
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/exports/magpie-exported-datasource-file.js